import { useDebouncedEffect } from '@coverright/utils';
import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';
import { PlanSelector, PlanSelectorPlan, PlanSelectorProps } from './plan-selector';
import { useState } from 'react';
import { usePdpPlanListLazyQuery } from '@coverright/data-access/medicare';
import { PdpField, PdpSort } from '@coverright/data-access/types/medicare';
import { Tooltip } from '@coverright/ui/inputs';
import { Box } from '@mui/material';

export const PdpPlanSelector = (props: PlanSelectorProps) => {
  const {zip, county, planYear, carrierName, onLoaded} = props;

  const [plans, setPlans] = useState<PlanSelectorPlan[]>([]);

  const [getPlans, {loading}] = usePdpPlanListLazyQuery({
    client: mainBackendApolloClient,
    onCompleted: data => {
      setPlans(data.PdpPlans.data);
      onLoaded && onLoaded(data.PdpPlans.data);
    }
  })

  useDebouncedEffect(() => {
    if (county && zip) {
      const filter = {
        countyName: county,
        zip,
        companies: carrierName ? [carrierName] : null,
        showAllPlans: true,
        planYear
      };

      getPlans({
        variables: {
          page: {
            size: 1000,
            page: 0
          },
          sort: [{direction: PdpSort.Asc, pdpField: PdpField.Name}],
          filter
        }
      })
    }
  }, 300, [carrierName, county, zip, planYear])

  return <Tooltip sx={{flex: 1, display: 'flex'}} title={carrierName ? '' : 'You have to select carrier to select plan'}>
    <Box>
      <PlanSelector {...props} plans={plans} loading={loading} />
    </Box>
  </Tooltip>
};
